<template>
  <v-card class="main-card">
    <v-card-title class="justify-end">
      <h3>Pembuatan Surat</h3>
    </v-card-title>
    <v-tabs v-model="tab" class="pl-5">
      <v-tab
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="outpatient"
        style="letter-spacing: 0.001px;"
        class="text-none font-weight-bold"
      >
        <span :class="hasAlert('Surat Kontrol Rawat Jalan') ? 'alert' : ''">
          Surat Kontrol RJ
        </span>
      </v-tab>
      <v-tab
        v-if="
          !isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="inpatient"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Perintah Rawat Inap') ? 'alert' : ''">
          Surat Perintah RI
        </span>
      </v-tab>
      <v-tab
        v-if="
          (isBpjs && isInpatient) ||
            (isBpjs && isIGD) ||
            (isBpjs && isGeneral) ||
            (isBpjs && isDental) ||
            (isBpjs && isKIA) ||
            (isBpjs && isVaccine) ||
            (isBpjs && isPhysioterapist) ||
            (isBpjs && isKB)
        "
        key="hospitalPcare"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Rujukan ke Rumah Sakit') ? 'alert' : ''">
          Surat Rujukan ke RS
        </span>
      </v-tab>
      <v-tab
        v-if="
          (!isBpjs && isInpatient) ||
            (!isBpjs && isIGD) ||
            (!isBpjs && isGeneral) ||
            (!isBpjs && isDental) ||
            (!isBpjs && isKIA) ||
            (!isBpjs && isVaccine) ||
            (!isBpjs && isPhysioterapist) ||
            (!isBpjs && isKB)
        "
        key="hospital"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Rujukan ke Rumah Sakit') ? 'alert' : ''">
          Surat Rujukan ke RS
        </span>
      </v-tab>
      <v-tab
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="mortality"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Keterangan Kematian') ? 'alert' : ''">
          Surat Keterangan Kematian
        </span>
      </v-tab>
      <v-tab
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="sick"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Keterangan Sakit') ? 'alert' : ''">
          Surat Keterangan Sakit
        </span>
      </v-tab>
      <v-tab
        v-if="
          !isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="healthy"
        class="text-none font-weight-bold"
        style="letter-spacing: 0.001px;"
      >
        <span :class="hasAlert('Surat Keterangan Dokter') ? 'alert' : ''">
          Surat Keterangan Dokter
        </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="outpatient"
      >
        <OutpatientWarrant
          ref="formOutpatientWarrant"
          :is-has-unprinted-letter="hasAlert('Surat Kontrol Rawat Jalan')"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          !isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="inpatient"
      >
        <InpatientWarrant
          ref="formInpatientWarrant"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          :is-has-unprinted-letter="hasAlert('Surat Perintah Rawat Inap')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          (isBpjs && isInpatient) ||
            (isBpjs && isIGD) ||
            (isBpjs && isGeneral) ||
            (isBpjs && isDental) ||
            (isBpjs && isKIA) ||
            (isBpjs && isVaccine) ||
            (isBpjs && isPhysioterapist) ||
            (isBpjs && isKB)
        "
        key="hospitalPcare"
      >
        <HospitalPcare
          ref="formHospitalPcare"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          :is-has-unprinted-letter="hasAlert('Surat Rujukan ke Rumah Sakit')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          (!isBpjs && isInpatient) ||
            (!isBpjs && isIGD) ||
            (!isBpjs && isGeneral) ||
            (!isBpjs && isDental) ||
            (!isBpjs && isKIA) ||
            (!isBpjs && isVaccine) ||
            (!isBpjs && isPhysioterapist) ||
            (!isBpjs && isKB)
        "
        key="hospital"
      >
        <Hospital
          ref="formHospital"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          :is-has-unprinted-letter="hasAlert('Surat Rujukan ke Rumah Sakit')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="mortality"
      >
        <Mortality
          ref="formMortality"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          :is-has-unprinted-letter="hasAlert('Surat Keterangan Kematian')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="sick"
      >
        <Sick
          ref="formSick"
          :is-has-unprinted-letter="hasAlert('Surat Keterangan Sakit')"
          :patient-data="patientData"
          @get-letter-status="resolveGetStatusLetter"
          @close-form="$emit('close-form')"
        />
      </v-tab-item>
      <v-tab-item
        v-if="
          !isInpatient ||
            isIGD ||
            isGeneral ||
            isDental ||
            isKIA ||
            isVaccine ||
            isPhysioterapist ||
            isKB
        "
        key="healthy"
      >
        <Healthy
          ref="formHealthy"
          :patient-data="patientData"
          @close-form="$emit('close-form')"
          :is-has-unprinted-letter="hasAlert('Surat Keterangan Dokter')"
          @get-letter-status="resolveGetStatusLetter"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import OutpatientWarrant from './OutpatientWarrant';
import InpatientWarrant from './InpatientWarrant';
import Hospital from './Hospital';
import HospitalPcare from './HospitalPcare';
import Mortality from './Mortality';
import Sick from './Sick';
import Healthy from './Healthy';

import { getStatusPrintLetter } from '@/fetchApi/Letter';

export default {
  components: {
    OutpatientWarrant,
    InpatientWarrant,
    Hospital,
    HospitalPcare,
    Mortality,
    Sick,
    Healthy,
  },
  props: {
    patientData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    route() {
      return this.$route.path;
    },
    routeSplit() {
      return this.$route.path.split('/');
    },
    routeController() {
      return this.routeSplit[2];
    },
    isInpatient() {
      return this.routeController === 'unit-rawat-inap';
    },
    isIGD() {
      return this.routeController === 'igd';
    },
    isGeneral() {
      return this.routeController === 'poli-umum';
    },
    isPhysioterapist() {
      return this.routeController === 'poli-fisioterapi';
    },
    isDental() {
      return this.routeController === 'poli-gigi';
    },
    isKIA() {
      return this.routeController === 'poli-KIA';
    },
    isKB() {
      return this.routeController === 'poli-kb';
    },
    isVaccine() {
      return this.routeController === 'poli-imunisasi';
    },
  },
  data() {
    return {
      alerts: [],
      tab: null,
      isBpjs:
        this.patientData.meta.guarantorType.toLowerCase() == 'bpjs'
          ? true
          : false,
    };
  },
  mounted() {
    this.resolveGetStatusLetter();
  },
  watch: {
    tab: {
      handler() {
        const formRefs = [
          'formOutpatientWarrant',
          'formInpatientWarrant',
          'formHospitalPcare',
          'formHospital',
          'formMortality',
          'formHealthy',
          'formSick',
        ];

        formRefs.forEach(refName => {
          const formRef = this?.$refs[refName];
          formRef && formRef.$refs?.form?.resetValidation();
        });
      },
      deep: true,
    },
  },
  methods: {
    hasAlert(name) {
      return (
        this.alerts.filter(
          item =>
            item.name.toLowerCase() === name.toLowerCase() && !item.status,
        ).length > 0
      );
    },
    async resolveGetStatusLetter() {
      const response = await getStatusPrintLetter(
        this.patientData.id_registration,
      );
      this.alerts = Object.values(response.data.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-card {
  font-family: 'Roboto', sans-serif;
}
::v-deep input,
::v-deep textarea,
::v-deep .v-select__selections {
  font-size: 14px;
}

::v-deep .v-text-field__suffix {
  font-size: 14px;
  font-weight: 700;
}

.alert {
  position: relative;
  display: inline-block;
}

.alert::after {
  content: '';
  position: absolute;
  top: -5px; /* Adjust to position the circle */
  right: -6px; /* Adjust to position the circle */
  width: 7px; /* Circle width */
  height: 7px; /* Circle height */
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}
</style>
